import { useSoyuzData } from '@spotahome/soyuz/client';
import {
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  UserInfoProvider,
  AppBanner,
  LoginSignupModalWrapper
} from '@spotahome/ui-library';

// Styles
import '@spotahome/landings-common/src/scss/init.scss';

import ContractTypes from './components/ContractTypes';

const ContractTypesContainer = () => {
  const { [ContractTypesContainer.NAME]: requestedData } = useSoyuzData();

  return (
    <CookiesProvider initialCookie={requestedData.initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <AppBanner source="home" deviceType={requestedData.deviceType} />
          <ToastContainer />
          <ContractTypes />
          <LoginSignupModalWrapper
            deviceViewType={requestedData.deviceViewType}
          />
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

ContractTypesContainer.NAME = 'ContractTypesContainer';

ContractTypesContainer.requestData = req => ({
  data: {
    deviceType: req.device.type,
    deviceViewType: req.device.viewType,
    initialCookie: req.headers.cookie
  }
});

export default ContractTypesContainer;
